import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-client-secret',
  imports: [MatDialogContent, MatDialogTitle, MatDialogActions, MatButton, TranslateModule],
  templateUrl: './modal-client-secret.component.html',
  styleUrl: './modal-client-secret.component.scss'
})
export class ModalClientSecretComponent {
  readonly dialogRef = inject(MatDialogRef<ModalClientSecretComponent>);
  readonly data = inject<{ client_secret: string }>(MAT_DIALOG_DATA);

  close(): void {
    this.dialogRef.close();
  }
}
